import React from 'react'
import * as styles from './index.module.css'
import { dynamicSort } from '../../utils'
import styled, { css } from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'

const LidarArchitecture = (props) => {
  return (
    <div className={styles.bgContainer}>
      <div className="wrapper">
        <div className={styles.container}>
          <section className={styles.section}>
            <h2 className={styles.title}>{props.title}</h2>
            <div className={styles.specList}>
              {props.components.sort(dynamicSort('order')).map((block, idx) => (
                <div className={styles.specBox} key={idx}>
                  {
                    <GradientBorder
                      height="1px"
                      style={{
                        marginBottom:
                          typeof window !== `undefined` &&
                          window.innerWidth > 450
                            ? '15px'
                            : '14px',
                      }}
                    />
                  }
                  <h3 className={styles.specTitle}>{block.title}</h3>
                  <div className={`${styles.specDescription} h3`}>
                    {block.subtitle.subtitle}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
      <section className={`${styles.section} ${styles.backdropImageSection}`}>
        <GatsbyImage
          image={props.images[0].gatsbyImageData}
          alt={props.images[0]?.description}
          style={{ height: '100%', width: '100%' }}
        />
      </section>
    </div>
  )
}

export default LidarArchitecture
